import React from 'react'
import theme from 'redesign/themes/main'
import SvgWrapper from '../SvgWrapper'
import { ICON_SIZE, ICON_VIEWBOX } from './constants'
import type { IconProps } from './types'

const PersonalDataIcon: React.FC<IconProps> = ({
  color = theme.palette.error.main,
  size = ICON_SIZE.medium,
  viewBox = ICON_VIEWBOX.medium,
  fillOpacity,
  isFilled,
}) => {
  const path = isFilled ? (
    <path
      d="M7.71484 3c.66582.00005 1.30989.30757 1.71582.85059l1.50004 1.98242h8.9257c1.1854.00022 2.1435.9504 2.1436 2.12597V17.874c-.0002 1.1755-.9582 2.1258-2.1436 2.126H4.14355C2.95824 19.9997 2.00017 19.0494 2 17.874V5.12598C2.0002 3.95058 2.95827 3.00034 4.14355 3h3.57129Zm4.39746 5.9502c-.5771.00005-1.131.23491-1.5391.65429-.408.41941-.63662.98881-.63668 1.58201l.00196.1114c.02676.5526.25232 1.0775.63472 1.4707.1446.1485.3078.2738.4834.374-.5737.1651-1.10246.4792-1.53121.9199C8.86916 14.7371 8.5 15.6524 8.5 16.6064c.00018.1359.09599.2473.22168.2706l-.00195.0058h6.56057c-.0005-.0018-.0015-.004-.002-.0058.1256-.0233.2215-.1348.2217-.2706 0-.9541-.369-1.8692-1.0254-2.5439-.3931-.404-.8699-.7019-1.3887-.876.207-.1064.3987-.2466.5655-.4179.3824-.3932.608-.9181.6347-1.4707l.002-.1114c-.0001-.5932-.2286-1.1626-.6367-1.58201-.4081-.41938-.962-.65424-1.5391-.65429Z"
      fill={color}
      fillOpacity={fillOpacity}
    />
  ) : (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 5.8252c1.3936.00019 2.5234 1.12092 2.5234 2.50292-.0002.7947-.3754 1.50076-.958 1.95898.929.4171 1.6722 1.1862 2.0469 2.124l.1025.2901.0176.0703c.0701.3527-.1391.708-.4931.8154-.3543.1072-.7286-.071-.8692-.4023l-.0244-.0684-.0654-.1855c-.3636-.9083-1.2703-1.5624-2.2803-1.5625-1.07731 0-2.03603.7451-2.34473 1.748l-.02539.0684c-.14057.3314-.51484.5095-.86914.4023-.37784-.1145-.59078-.5109-.47558-.8857l.10254-.2901c.37459-.9375 1.11703-1.7069 2.04589-2.124-.58243-.45823-.95682-1.1645-.95703-1.95898C7.47656 6.94608 8.6062 5.8253 10 5.8252Zm0 1.41894c-.60307.0001-1.0918.486-1.0918 1.08398.00037.59775.48894 1.08193 1.0918 1.08204.6027-.00019 1.0914-.48437 1.0918-1.08204 0-.59791-.4889-1.08379-1.0918-1.08398Z"
        fill={color}
        fillOpacity={fillOpacity}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.71484 0c.66582.0000488 1.30989.307572 1.71582.850586l1.5 1.982424h8.92574c1.1854.00022 2.1435.9504 2.1436 2.12597V14.874c-.0002 1.1755-.9582 2.1258-2.1436 2.126H2.14355C.958236 16.9997.0001748 16.0494 0 14.874V2.12598C.0001993.950583.95827.0003406 2.14355 0h3.57129ZM2.14355 1.41992c-.39457.00034-.71171.31475-.71191.70606V14.874c.00017.3913.31734.7057.71191.7061H17.8564c.3947-.0002.7118-.3147.712-.7061V4.95898c-.0001-.39145-.3172-.70583-.712-.70605H8.57129c-.22501-.00014-.43716-.10575-.57227-.28418l-1.71386-2.2666-.00391-.00391c-.12747-.17155-.33919-.27827-.56641-.27832H2.14355Z"
        fill={color}
        fillOpacity={fillOpacity}
      />
    </>
  )

  return (
    <SvgWrapper aria-label="personal data icon" size={size} viewBox={viewBox} fill="none">
      {path}
    </SvgWrapper>
  )
}

export default PersonalDataIcon
